import { useValidation } from '@application/utils';
import { useMemo } from 'react';
import { object, number, string, array, mixed } from 'yup';

export const useValidationSchema = () => {
  const { requiredMessage } = useValidation();

  const applicationValidationSchema = useMemo(() => {
    return object({
      otherAnimals: array().of(string()).min(1, requiredMessage).required(requiredMessage),
      accommodation: string().required(requiredMessage),
      experiences: string().required(requiredMessage),
      timeAlone: string().required(requiredMessage),
      trainers: array().of(string()).min(1, requiredMessage).required(requiredMessage),
      motive: string().required(requiredMessage),
      breedPreferenceId: number().required(requiredMessage),
      genderPreferences: string().required(requiredMessage),
    });
  }, [requiredMessage]);

  return { applicationValidationSchema };
};
